// Header.jsx
import React, { useState } from "react";
import { Container, Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  BsBell,
  BsGear,
  BsPerson,
  BsList,
  BsX,
  BsBoxArrowRight,
} from "react-icons/bs";
import "../../styles/custom.css";

const Header = ({ mobileOpen, setMobileOpen, onLogout }) => {
  const [showDropdown, setShowDropdown] = useState(false);

  const toggleMobileSidebar = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleLogout = () => {
    if (onLogout) {
      onLogout();
    }
  };

  return (
    <header className="header d-flex align-items-center">
      <Container
        fluid
        className="d-flex justify-content-between align-items-center"
        style={{ height: "10vh" }}
      >
        <div className="d-flex align-items-center">
          <button
            className="toggle-btn btn btn-link d-block d-md-none"
            onClick={toggleMobileSidebar}
            aria-label={mobileOpen ? "Close sidebar" : "Open sidebar"}
          >
            {mobileOpen ? <BsX size={24} /> : <BsList size={24} />}
          </button>
          <div className="logo">
            <img
              src="/ai4m_logo.png"
              alt="Logo"
              style={{ height: "50px", width: "50px" }}
            />
          </div>
        </div>

        <span className="fw-medium me-4 head-title">Suhana Yawat</span>

        <div className="d-flex align-items-center">
          <div className="d-flex align-items-center">
            <BsBell className="mx-2 header-icon" size={18} />
            <BsGear className="mx-2 header-icon" size={18} />

            <Dropdown
              show={showDropdown}
              onToggle={(isOpen) => setShowDropdown(isOpen)}
            >
              <Dropdown.Toggle
                as="div"
                className="cursor-pointer bg-light rounded-circle p-1 ms-2"
              >
                <BsPerson size={18} />
              </Dropdown.Toggle>

              <Dropdown.Menu align="end" className="mt-2 shadow-sm">
                <Dropdown.Item as={Link} to="/profile">
                  <BsPerson className="me-2" /> Profile
                </Dropdown.Item>
                <Dropdown.Item as={Link} to="/settings">
                  <BsGear className="me-2" /> Settings
                </Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Item onClick={handleLogout}>
                  <BsBoxArrowRight className="me-2" /> Logout
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>

          <div className="logo ms-3">
            <img
              src="/Suhana_Logo.jpg"
              alt="Logo"
              style={{ height: "45px", width: "90px" }}
            />
          </div>
        </div>
      </Container>
    </header>
  );
};

export default Header;
